import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { IMPORT_PATH, TABS } from '../constants';
import { useProfitIqContext } from '../context/ProfitIqContext';

/**
 * Cross-tab navigation. Card footers on one tab open another, and the Insights
 * tab is entered pre-drilled from elsewhere, so the target topic and question
 * are set before the route changes.
 */
export function useProfitIqTabs() {
  const history = useHistory();
  const { insightTopic, setInsightTopic, insightQ, setInsightQ } =
    useProfitIqContext();

  const goToTab = useCallback(
    (key) => {
      const tab = TABS.find((t) => t.key === key);
      if (tab) history.push(tab.path);
    },
    [history]
  );

  const goToImport = useCallback(() => history.push(IMPORT_PATH), [history]);

  const goToInsight = useCallback(
    (topic, question = null) => {
      setInsightTopic(topic);
      setInsightQ(question);
      goToTab('insights');
    },
    [goToTab, setInsightQ, setInsightTopic]
  );

  return {
    goToTab,
    goToImport,
    goToInsight,
    insightTopic,
    setInsightTopic,
    insightQ,
    setInsightQ,
  };
}

export default useProfitIqTabs;
